/* Product recommendations (sections/product-recommendations.liquid).

   Shopify fills the `recommendations` object on one route only, so the section is rendered twice:
   the template puts an empty shell on the page, and this file asks that route for the real thing
   and swaps it in. The cards come back as Liquid wrote them — prices, badges and availability are
   the server's, exactly as in the cart.

   It waits until the shell is near the viewport: a recommendation below the fold is not worth a
   request while the shopper is still reading the product. */

const SHELL = '[data-recommendations]';
const MARGIN = '600px 0px';

async function fill(shell) {
  const url = shell.dataset.url;
  if (!url || shell.dataset.done) return;
  shell.dataset.done = '1';

  try {
    const response = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(response.statusText);
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    /* The route answers with the whole section; only its contents belong in the shell. */
    const fresh = parsed.querySelector('.prec__inner');
    if (!fresh) {
      /* No recommendations for this product: leave the page as it was rather than print a
         heading above nothing. */
      shell.remove();
      return;
    }
    shell.replaceChildren(fresh);
    shell.classList.add('is-filled');
    window.Munkwell?.motion?.scan?.(shell);
  } catch {
    shell.remove();
  }
}

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, self) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            self.unobserve(entry.target);
            fill(entry.target);
          });
        },
        { rootMargin: MARGIN }
      )
    : null;

function scan(scope = document) {
  scope.querySelectorAll(SHELL).forEach((shell) => {
    if (observer) observer.observe(shell);
    else fill(shell);
  });
}

scan();
document.addEventListener('shopify:section:load', (event) => scan(event.target));
